<template>
    <v-layout>
        <v-dialog v-model="isShowDialog" max-width="38rem" :persistent="loading">
            <v-card>
                <v-card-title class="secondary elevation-4 white--text">
                    <div class="text-h5">
                        <v-icon class="pb-1" color="white" medium> sync </v-icon>
                        {{ $t('Domain_User_Synchronous') }}
                    </div>
                </v-card-title>
                <v-card-text class="pa-4">
                    {{ $t('Perform_domain_user_synchronization_process.') }} {{ $t('It_is_OK?') }}
                    <alert-warning>
                        <ul>
                            <li v-for="(message, index) in messages" :key="index">
                                {{ $t(message) }}
                            </li>
                        </ul>
                    </alert-warning>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <button-app-control
                        ref="cancel-btn"
                        :disabled="disabled"
                        :label="$t('Cancel')"
                        text
                        @click="closeDialog()"
                    />
                    <button-app-control
                        ref="submit-btn"
                        :disabled="disabled"
                        :loading="loading"
                        :label="$t('Synchronous')"
                        :icon="'sync'"
                        @click="submit()"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AlertWarning, ButtonAppControl } from '../../atoms';

@Component({
    name: 'TheSyncDialog',
    components: {
        AlertWarning,
        ButtonAppControl,
    },
})
export default class TheSyncDialog extends Vue {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) loading: boolean;

    messages = [
        'This_process_can_take_a_long_time',
        'Update_domain_users_with_domain_controller_information',
        'Users_that_longer_exist_on_the_domain_controller_or_are_out_of_sync_will_be_removed_from_the_domain_user',
    ];

    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }
    closeDialog(): void {
        this.$emit('cancel');
    }
    submit(): void {
        this.$emit('submit');
    }
}
</script>
